import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { useLanguageSettings } from '@/features/settings/hooks/use-language-settings';

export function Settings() {
  const { t } = useTranslation(['settings']);
  const { selectedLanguage, handleLanguageChange, languages } =
    useLanguageSettings();

  return (
    <div className='flex flex-col gap-8'>
      <div className='grid grid-cols-2 gap-4 p-6'>
        <div className='flex flex-col gap-1'>
          <span className='font-semibold text-lg'>{t('application')}</span>
          <span className='text-layout-foreground-secondary text-sm'>
            {t('change the application settings')}
          </span>
        </div>
        <div className='col-span-1 flex w-full flex-col gap-4 pr-14 font-medium text-sm'>
          <div className='flex flex-row gap-2'>
            {languages.map((language) => (
              <button
                className={`group relative overflow-hidden rounded-md border transition-all duration-200 ${
                  selectedLanguage === language.code
                    ? 'border-primary bg-primary/5'
                    : 'border-input bg-background hover:border-primary/40'
                }`}
                key={language.code}
                onClick={() => handleLanguageChange(language.code)}
                type='button'
              >
                <Card className='border-0 bg-transparent px-3 py-2 shadow-none'>
                  <div className='flex items-center gap-2'>
                    <span className='text-xl transition-transform duration-200 group-hover:scale-105'>
                      <ReactCountryFlag countryCode={language.flagKey} svg />
                    </span>
                    <span className='font-medium text-foreground text-sm'>
                      {t(language.code)}
                    </span>
                  </div>
                </Card>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
